__turbopack_context__.v({
  "completedLabel": "ProgressBar-module__YNqnaG__completedLabel",
  "container": "ProgressBar-module__YNqnaG__container",
  "fillEffect": "ProgressBar-module__YNqnaG__fillEffect",
  "labelContainer": "ProgressBar-module__YNqnaG__labelContainer",
  "progress-bar-stripes": "ProgressBar-module__YNqnaG__progress-bar-stripes",
  "progressBar": "ProgressBar-module__YNqnaG__progressBar",
  "progressBarContainer": "ProgressBar-module__YNqnaG__progressBarContainer",
  "status-completed": "ProgressBar-module__YNqnaG__status-completed",
  "status-pending": "ProgressBar-module__YNqnaG__status-pending",
  "status-processing": "ProgressBar-module__YNqnaG__status-processing",
});
